import { render, staticRenderFns } from "./LogoutConfirm.vue?vue&type=template&id=25d36162"
import script from "./LogoutConfirm.vue?vue&type=script&lang=js"
export * from "./LogoutConfirm.vue?vue&type=script&lang=js"
import style0 from "./LogoutConfirm.vue?vue&type=style&index=0&id=25d36162&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports